<template>
  <div class="pacing-effect">
    <el-input
      :value="state.effect.duration"
      class="duration-input"
      :controls="false"
      placeholder="Duration"
      :disabled="readonly"
      type="number"
      :min="0"
      @input="duration => updateEffectDuration(duration)"
    >
      <template slot="prepend">over</template>
      <template slot="append">s</template>
    </el-input>
  </div>
</template>

<script>
export default {
  name: 'pacing-effect',
  components: {},
  props: ['readonly', 'emitter', 'ikey', 'getData', 'putData', 'control'],
  data() {
    return {
      state: {
        effect: {
          duration: 0,
        },
      },
      value: 0,
    };
  },
  computed: {},
  mounted() {
    this.state.effect = this.getData(this.ikey) || {};
    this.update();
  },
  methods: {
    updateEffectDuration(duration) {
      this.state.effect.duration = duration;
      this.update();
    },
    update() {
      this.putData(this.ikey, {
        ...this.state.effect,
        type: 'VITAL',
        id: 'HEART_RATE',
        matchInput: true,
        isAbsolute: true,
      });
      this.emitter.trigger('process', this.control);
      this.$forceUpdate();
    },
  },
};
</script>

<style scoped>
</style>
